import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.produceState
import kotlinx.browser.window
import kotlinx.coroutines.await
import com.bikompanion.domain.catchingRequest
import com.bikompanion.ui.install.AppInstallOffer
import com.bikompanion.ui.install.browserInstallOffer
import kotlin.js.Promise

/** Null until the check for the native app has answered, so nobody who has it sees the offer flash. */
@Composable
fun rememberBrowserInstallOffer(): AppInstallOffer? {
    val offer by produceState<AppInstallOffer?>(initialValue = null) { value = currentBrowserInstallOffer() }
    return offer
}

private suspend fun currentBrowserInstallOffer(): AppInstallOffer? =
    browserInstallOffer(
        userAgent = window.navigator.userAgent,
        maxTouchPoints = window.navigator.asDynamic().maxTouchPoints as? Int ?: 0,
        isInstalled = isRunningInstalled() || isNativeAppInstalled(),
    )

// `navigator.standalone` is the only signal on iOS versions without the display-mode query.
private fun isRunningInstalled(): Boolean =
    window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.asDynamic().standalone == true

/**
 * Only Chrome on Android can answer, and only for an app whose `asset_statements` name this site and
 * which the web manifest lists. Everywhere else this is false, which just means the offer stays.
 */
private suspend fun isNativeAppInstalled(): Boolean {
    val navigator = window.navigator.asDynamic()
    if (navigator.getInstalledRelatedApps == undefined) return false
    return catchingRequest {
        navigator
            .getInstalledRelatedApps()
            .unsafeCast<Promise<Array<dynamic>>>()
            .await()
            .isNotEmpty()
    }.getOrDefault(false)
}
